/* eslint newline-before-return: "error" */
import { updateCategory } from '../../Api/request/certificationCategoryMaster';
import UseAxios from '../../Api/http/http';
import {
  ENABLE_DISABLE_CATEGORY_DIALOG,
  AUTHENTICATION_FAILED,
} from '../../Constants/strings';
import { STATUS_CODES } from '../../Api/resources/statusCodes';

export const handleDialogSubmit = async (
  data,
  setRows,
  setIsDialogOpen,
  handleSnackbar,
  setIsEdit,
) => {
  // Operations to be performed on enabling/disabling role
  let isActive = data.is_active || data.isActive;
  isActive = Number(isActive) ? 0 : 1;

  const categoryData = {
    isActive: isActive,
    lastUpdatedBy: data.last_updated_by,
    categoryId: data.categoryId,
    subCategoryId: data.id,
    categoryName: data.categoryName,
    subCategories: data.subCategoryName,
  };

  try {
    const response = await UseAxios(updateCategory(categoryData));
    // API call to enable/disable role
    if (response.data.status !== STATUS_CODES.SUCCESS) {
      const errorStatus = response.data.response.status;

      handleDialogClose(setIsDialogOpen, setIsEdit);
      let snackbarMessage = ENABLE_DISABLE_CATEGORY_DIALOG.OOPS_TRY_AGAIN;
      if (errorStatus === STATUS_CODES.INVALID_REQUEST) {
        snackbarMessage = ENABLE_DISABLE_CATEGORY_DIALOG.CANNOT_DISABLE;
      } else if (errorStatus === STATUS_CODES.UNAUTHORIZED) {
        snackbarMessage = AUTHENTICATION_FAILED;
      }
      handleSnackbar(snackbarMessage, 'warning', 'enable-disable-warning-snackbar');
      throw new Error('Failed to enable/disable category');
    }

    setRows((prevRows) =>
      prevRows.map((row) => {
        if (categoryData.subCategoryId === row.subCategoryId) {
          row.isActive = categoryData.isActive; // Update the isActive value of updated row
        }
        // Close the dialog, after successful API response
        handleDialogClose(setIsDialogOpen, setIsEdit);
        const message_1 = categoryData.isActive
          ? ENABLE_DISABLE_CATEGORY_DIALOG.ENABLE.RESPONSE_SUCCESS
          : ENABLE_DISABLE_CATEGORY_DIALOG.DISABLE.RESPONSE_SUCCESS;
        handleSnackbar(message_1, 'success', 'enable-disable-success-snackbar');

        return row;
      }),
    );
  } catch (error) {
    console.error(error);
  }
};

export const handleDialogClose = (setIsDialogOpen, setIsEdit) => {
  // Close the dialog
  setIsDialogOpen(false);
  setIsEdit(false);
};
